/**
 * Created by vladislav on 21.07.20.
 */

cleverapps.BoardView.prototype.animateOpenLetter = function (row, col, options, callback) {
    const letter = this.board.field[row].charAt(col);

    options = options || {}; 
    callback = callback || function () {};
    if (options.keypadLetter) {
        this.runLetterFlyAnimation(row, col, letter, options.keypadLetter, callback);
        return;
    }

    if (options.type === cleverapps.Board.HINT_LETTER_ANIMATION) {
        const indexes = this.board.game.keypad.findWordIndexes(this.board.words[row]);
        const start = BaseBlockView.GetView(indexes[col]);

        this.animateHintLetter(letter, row, col, start);
        return;
    }

    if (this.grid.isExistsCell(row, col)) {
        const letterSprite = this.createLetter(letter);
        this.grid.putInCell(row, col, letterSprite, row, cleverapps.Board.LETTER_LAYER);

        this.letters[`${row}_${col}`] = letterSprite;
    }

    callback();
};

cleverapps.BoardView.prototype.beforeDiscover = function (word) {
    this.letterSprites = [];

    const indexes = this.board.listWordIndexes(word);

    const wordBg = this.wordBg = this.createWordBg(indexes, true);
    const wordBgWidth = wordBg.width;
    const wordBgOriginalPos = wordBg.getPosition();
    wordBg.setAnchorPoint(0, 0.5);
    wordBg.setAlignment(wordBgOriginalPos.x - wordBgWidth / 2, wordBg.y);
    wordBg.setContentSize2(0, wordBg.height);

    this.letterBgWidth = wordBgWidth / indexes.length;
};

cleverapps.BoardView.prototype.afterDiscover = function (word, silent, callback) {
    callback = callback || function () {};

    const indexes = this.board.listWordIndexes(word);
    const wordBg = this.createWordBg(indexes);

    const oldWordBg = this.wordBg;
    const letterSprites = Array.isArray(this.letterSprites) && this.letterSprites.slice();
    this.letterSprites = [];

    const clearLetterPlaceholders = function (_indexes) {
        _indexes.forEach((index) => {
            this.grid.getCell(index[0], index[1]).setVisible(false);
            this.letters[`${index[0]}_${index[1]}`] && this.letters[`${index[0]}_${index[1]}`].setVisible(false);
        });
    }.bind(this);

    if (silent) {
        this.addWord(word, wordBg);
        oldWordBg && oldWordBg.removeFromParent();

        clearLetterPlaceholders(indexes);

        letterSprites && letterSprites.forEach((sprite) => {
            sprite.removeFromParent();
        });

        callback();
    } else {
        wordBg.setVisible(false);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.5),
            new cc.CallFunc(() => {
                oldWordBg && oldWordBg.removeFromParent();
                wordBg.setVisible(true);

                letterSprites && letterSprites.forEach((sprite) => {
                    sprite.removeFromParent();
                });

                const text = this.addWord(word, wordBg);
                text.runAction(new cc.Sequence(
                    new cc.ScaleTo(0.2, 1.1),
                    new cc.ScaleTo(0.2, 1)
                ));

                wordBg.runAction(new cc.Sequence(
                    new cc.ScaleTo(0.2, 1.1),
                    new cc.ScaleTo(0.2, 1)
                ));

                clearLetterPlaceholders(indexes);

                cleverapps.effects.fire("scramble.letters");

                callback();
            })
        ));
    }
};

cleverapps.BoardView.prototype.createWordBg = function (indexes, forAnim) {
    const placeholder = new cc.Sprite(bundles.game.frames.placeholder_png);

    const bg = new cc.Scale9Sprite(cleverapps.BoardView.foundWordBg);
    this.grid.addChild(bg);
    bg.setLocalZOrder(1);
    bg.onResize = function (init) {
        const minX = this.grid.getCell(indexes[0][0], indexes[0][1]).x;
        const maxX = this.grid.getCell(indexes[indexes.length - 1][0], indexes[indexes.length - 1][1]).x;
        if (forAnim && !init) {
            bg.setAlignment(minX - this.grid.getCell(indexes[0][0], indexes[0][1]).width / 2, this.grid.getCell(indexes[0][0], indexes[0][1]).y);
        } else {
            bg.setContentSize(maxX - minX + placeholder.width + cleverapps.styles.BoardView.wordBg.padding, placeholder.height);
            bg.setAlignment((maxX + minX) / 2, this.grid.getCell(indexes[0][0], indexes[0][1]).y);
        }
    }.bind(this);
    bg.onResize(true);
    bg.setCascadeOpacityEnabled(true);
    return bg;
};

cleverapps.BoardView.prototype.runLetterFlyAnimation = function (row, col, letter, keypadLetter, callback) {
    callback = callback || function () {};
    const styles = cleverapps.styles.BoardView.discoverAnimation;

    cleverapps.effects.fire("scramble.word.open");

    const letterFlyAnimation = function () {
        const letter = BaseBlockView.GetView(keypadLetter);

        letter.stopAllActions();
        letter.moveToBlock();
        letter.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(this), {
            keepScale: true
        });

        letter.setLocalZOrder(letter.getLocalZOrder() + 100);

        if (!letter || !letter.isRunning() || !letter.getParent()) {
            cleverapps.throwAsync("runLetterFlyAnimation letter error");
            return;
        }

        const placeholder = this.grid.getCell(row, col);
        const pos = placeholder.getPosition();
        pos.y += styles.letter.offsetY;
        const target = letter.getParent().convertToNodeSpace(placeholder.getParent().convertToWorldSpace(pos));

        const targetScale = cc.Base.AdjustScaleTo(letter, placeholder);
        targetScale.x = letter.getScaleX() / targetScale.x;
        targetScale.y = letter.getScaleY() / targetScale.y;

        const first = letter.getPosition();
        const third = target;
        const second = cc.p((first.x + 2 * third.x) / 3, (first.y + 2 * third.y) / 3 - styles.bezier.y);

        letter.runAction(new cc.Sequence(
            new cc.DelayTime(col * 0.05),
            new cc.Spawn(
                new cc.BezierTo(0.5, [first, second, third]),
                new cc.ScaleTo(0.5, targetScale.x, targetScale.y)
            ),
            new cc.RemoveSelf(),
            new cc.CallFunc(callback)
        ));
    }.bind(this);

    const placeholderAnimation = function () {
        const placeholder = this.grid.getCell(row, col);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.4 + col * 0.05),
            new cc.CallFunc(() => {
                if (this.letters[`${row}_${col}`]) {
                    this.letters[`${row}_${col}`].runAction(new cc.FadeOut(0.1));
                }
                placeholder.runAction(new cc.FadeOut(0.1));
            }),
            new cc.DelayTime(0.1),
            new cc.CallFunc(() => {
                this.collectMissionReward(row, col);
                this.letters[`${row}_${col}`] && this.letters[`${row}_${col}`].setVisible(false);
                placeholder.setVisible(false);
            })
        ));
    }.bind(this);

    const spriteAnimation = function () {
        const sprite = this.createLetter(letter);
        this.letterSprites.push(sprite);
        this.grid.addChild(sprite);

        sprite.visible = false;
        const placeholder = this.grid.getCell(row, col);
        sprite.runAction(new cc.Sequence(
            new cc.DelayTime(0.5 + col * 0.05),
            new cc.CallFunc(() => {
                this.wordBg.setContentSize2((col + 1) * this.letterBgWidth, this.wordBg.height);
                sprite.setAlignment(placeholder.x, placeholder.y + styles.sprite.offsetY);
                sprite.setLocalZOrder(2);
                sprite.visible = true;
            })
        ));
    }.bind(this);

    letterFlyAnimation();
    placeholderAnimation();
    spriteAnimation();
};

cleverapps.BoardView.prototype.addWord = function (word, parent) {
    const text = cleverapps.UI.generateOnlyText(word.toUpperCase(), cleverapps.styles.FONTS.BOARD_TEXT);
    if (!this.wordsBg) {
        this.wordsBg = [];
    }
    this.wordsBg.push(parent);
    this.grid.addChild(text);
    text.setLocalZOrder(1);
    text.onResize = function () {
        const styles = cleverapps.styles.BoardView.discoverAnimation;
        text.setFontSize(cleverapps.styles.FONTS.BOARD_TEXT.size);
        text.fitTo(undefined, styles.text.height);
        const position = text.getRelativeCoordinates(parent);
        text.setAlignment(position.x, position.y + styles.text.offsetY * this.grid.getScale());
    }.bind(this);
    text.onResize();

    return text;
};

cleverapps.BoardView.prototype.showUpAnimation = function (callback, silent) {
    if (silent) {
        this.setVisible(true);
        this.showUpBackground(true);
        this.hintView && this.hintView.showUp(() => {}, true);
        callback();
    } else {
        new ActionPlayer([
            (f) => {
                if (this.hintView) {
                    this.hintView.showUp(f, false);
                } else {
                    f();
                }
            },
            (f) => {
                this.setVisible(true);
                this.setOpacity(0);
                this.runAction(new cc.Spawn(
                    new cc.CallFunc(() => {
                        regularShowUp(this.grid.listCells(), 1.0);
                        this.showUpBackground(false);
                    }),
                    new cc.FadeIn(0.25),
                    new cc.Sequence(
                        new cc.DelayTime(1.2),
                        new cc.CallFunc(() => {
                            f();
                        })
                    )
                ));
            }
        ]).play(callback);
    }
};

cleverapps.BoardView.prototype.elementsHide = function () {
    const views = Object.values(this.stars)
        .concat(Object.values(this.grid.listCells()))
        .concat(Object.values(this.letters))
        .concat(this.wordsBg)
        .concat([this.grid]);

    views.filter(Boolean).forEach((view) => {
        if (view.highlightAnimation) {
            view.setOpacity(255);
            view.highlightAnimation.removeFromParent();
        }
        view.runAction(new cc.Spawn(
            new cc.FadeOut(0.5)
        ));
    });
};

cleverapps.BoardView.prototype.hideAnimation = function (f) {
    this.setCascadeOpacityEnabled(true);
    this.grid.setCascadeOpacityEnabled(true);

    this.runAction(new cc.Sequence(
        new cc.DelayTime(0.5),
        new cc.CallFunc(this.elementsHide.bind(this)),
        new cc.FadeOut(0.5),
        new cc.CallFunc(() => {
            this.setVisible(false);
            f();
        })
    ));
};

cleverapps.BoardView.prototype.showUpBackground = function (silent) {
    if (!this.boardBg) {
        return;
    }
    if (silent) {
        this.boardBg.setOpacity(255);
        return;
    }

    this.boardBg.setOpacity(0);
    this.boardBg.runAction(new cc.FadeIn(0.25));
};

cleverapps.BoardView.prototype.animateLastWord = function (indexes) {
    const animateLine = function (actionIndex, maxCountActions) {
        if (!Game.currentGame || Game.currentGame.outcome !== undefined || this.board.isComplete()) {
            return;
        }

        if (!maxCountActions) {
            maxCountActions = 1;
        }

        if (actionIndex === 0) {
            cleverapps.effects.fire("scramble.word.last");
        }

        indexes.forEach(function (pos, index) {
            const row = pos[0];
            const col = pos[1];

            const frame = new cc.Sprite(bundles.game.frames.board_letter_frame_png);
            this.grid.addChild(frame);
            frame.setAlignment(this.grid.getCell(row, col)
                .getPosition());
            frame.setOpacity(0);
            frame.setLocalZOrder(3);
            frame.runAction(new cc.Sequence(
                new cc.DelayTime(0.2 * index),
                new cc.CallFunc(() => {
                    if (this.board.isComplete()) {
                        frame.stopAllActions();
                    }
                }),
                new cc.FadeIn(0.2),
                new cc.FadeOut(0.2),
                new cc.CallFunc(() => {
                    if (index === indexes.length - 1) {
                        if (actionIndex === Math.max(maxCountActions - 1, 0)) {
                            this.runAction(new cc.Sequence(
                                new cc.DelayTime(10.0),
                                new cc.CallFunc(() => {
                                    animateLine(0, maxCountActions);
                                })
                            ));
                        } else {
                            animateLine(actionIndex + 1, maxCountActions);
                        }
                    }
                }),
                new cc.RemoveSelf()
            ));
        }, this);
    }.bind(this);

    this.runAction(
        new cc.Sequence(
            new cc.DelayTime(2.0),
            new cc.CallFunc(() => {
                animateLine(0);
            })
        )
    );
};

cleverapps.overrideStyles(cleverapps.styles.BoardView, {
    minSpaceX: 120,
    maxSpaceX: 200,

    Letter: {
        offset: 4,
        paddingBottom: 4
    },
    Coin: {
        paddingBottom: 6
    },
    Background: {
        width: "grid"
    },
    Star: {
        scale: 0.75,
        collect: {
            height: 250
        }
    },

    wordBg: {
        padding: 15
    },

    discoverAnimation: {
        letter: {
            paddingY: -10,
            offsetY: 0
        },
        sprite: {
            offsetY: 0
        },
        text: {
            offsetY: 2,
            height: 125
        },
        bezier: {
            y: 400
        },
        margin: -40
    }
});